import { useState } from "react";
import { Accordion, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function T8_talent_mnu({permission, setactivity, activeItem}) {
  const [isProductionOpen, setProductionOpen] = useState(true); // Predeterminadamente abierto
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };
 
 
  return (
    <Accordion.Item eventKey="4">
    <Accordion.Header>
      <span role="img" aria-label="talent">👥</span> Talent
    </Accordion.Header>
    <Accordion.Body className="p-0">
      <Nav className="flex-column">
      {permission !== '3' && (
          <>
          <Nav.Link active={activeItem === 'expenses'} style={activeItem === 'expenses' ? activeStyles : undefined} onClick={() => navigate('/expenses')}>Expenses Control</Nav.Link>
          <Nav.Link active={activeItem === 'awards'} style={activeItem === 'awards' ? activeStyles : undefined} onClick={() => navigate('/awards')}>Reconocimientos</Nav.Link>
          <Nav.Link active={activeItem === 'strategylist'} style={activeItem === 'strategylist' ? activeStyles : undefined} onClick={() => navigate('/strategylist')}>Estrategias</Nav.Link>
          </>
        )}
        {permission === '1' && (
          <>
            <Nav.Link active={activeItem === 'members_master'} style={activeItem === 'members_master' ? activeStyles : undefined} onClick={() => navigate('/members_master')}>Miembros</Nav.Link>
            <Nav.Link active={activeItem === 'stocks'} style={activeItem === 'stocks' ? activeStyles : undefined} onClick={() => navigate('/stocks')}>Stocks</Nav.Link>
          </>
        )}
       
      </Nav>
    </Accordion.Body>
  </Accordion.Item>
    
  );
}

export default T8_talent_mnu;
